import Rails from "@rails/ujs";
import swal from "sweetalert2";

Rails.confirm = function (message, element) {
  const swalWithBootstrap = swal.mixin({
    buttonsStyling: true,
  });

  swalWithBootstrap
    .fire({
      html: message,
      showCancelButton: true,
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
    })
    .then((result) => {
      if (result.value) {
        element.removeAttribute("data-confirm");
        if (element instanceof HTMLFormElement) {
          element.requestSubmit();
        } else {
          element.click();
        }
      }
    });
};
